import './style.scss'
import { Popover } from 'antd'
import dayjs from 'dayjs'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconScore } from '@/assets/svg/icon-score'
import { UserStore } from '@/global-states'
import { eventTracking, showPlanModal } from '@/libs/util'
import CheckLogin from '../CheckLogin'
import CreditDetailModal from '../CreditDetailModal'

const UserCredits = () => {
  const { t: translate } = useTranslation(['user_credits'])
  const { userPackage, uid } = UserStore
  const [creditDetailModalOpen, setCreditDetailModalOpen] = useState(false)

  const totalPoint = useMemo(() => {
    if (!userPackage) return 0
    return (
      (userPackage.membership_credits || 0) + (userPackage.permanent_credits || 0) + (userPackage.free_credits || 0)
    )
  }, [userPackage])

  const vipDateDesc = useMemo(() => {
    if (!userPackage?.membership_expire_time) {
      return translate('user_credits.no_membership')
    } else if (userPackage?.membership_expired) {
      return translate('user_credits.membership_expired', {
        date: dayjs.unix(userPackage.membership_expire_time).format('YYYY-MM-DD HH:mm:ss')
      })
    } else {
      return translate('user_credits.membership_will_expire', {
        date: dayjs.unix(userPackage.membership_expire_time).format('YYYY-MM-DD HH:mm:ss')
      })
    }
  }, [userPackage, translate])

  const vipDesc = useMemo(() => {
    const level = userPackage?.current_membership_level || 0
    if (!uid) {
      return translate('user_credits.get_membership')
    }
    return (
      {
        10: translate('user_credits.basic_member'),
        20: translate('user_credits.premium_member'),
        50: translate('user_credits.black_member'),
        100: translate('user_credits.enterprise_member')
      }[level] || translate('user_credits.get_membership_credit')
    )
  }, [userPackage?.current_membership_level, uid])

  const toViewCreditDetail = () => {
    eventTracking('ViewCreditDetail')
    setCreditDetailModalOpen(true)
  }

  if (!userPackage) return null

  return (
    <div className="common-user-credits">
      <div className="common-user-credits__wrapper">
        <CheckLogin>
          <div className="credits gradient" onClick={toViewCreditDetail}>
            <IconScore />
            {totalPoint}
          </div>
        </CheckLogin>
        <div className="split"></div>
        <CheckLogin>
          <div className="vip-desc gradient" onClick={() => showPlanModal()}>
            <Popover
              placement="bottomRight"
              className="vip-popver"
              content={
                <div>
                  {vipDateDesc}，
                  <span
                    className="gradient"
                    style={{
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    {translate('user_credits.subscribe_now')}
                  </span>
                </div>
              }
            >
              {vipDesc}
            </Popover>
          </div>
        </CheckLogin>
      </div>

      <CreditDetailModal open={creditDetailModalOpen} onCancel={() => setCreditDetailModalOpen(false)} />
    </div>
  )
}

export default UserCredits
